import { v4 as uuidv4 } from "uuid";
import { TABLET_WIDTH } from "@circle-react-shared/BuilderUI/Canvas/constants";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import communityImagePlaceholder from "@circle-react-shared/BuilderUI/DefaultBlocks/CallToAction/CardCallToAction/community_image_placeholder.png";
import userImagePlaceholder from "@circle-react-shared/BuilderUI/DefaultBlocks/CallToAction/CardCallToAction/user_image_placeholder.png";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/cardBlockHelper";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getMaxWidthOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getTextAlignOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { getHomepageBlockPrimaryStyleOptions } from "../constants";

const cards = [
  {
    image: {
      signedId: "",
      placeholder: userImagePlaceholder,
    },
    h5Text: "Personalized Coaching Approach",
    pText:
      "Unlike one-size-fits-all programs, we create a custom roadmap based on your unique strengths, challenges, and career aspirations. No generic advice—just strategies that work for Your situation.",
  },
  {
    image: {
      signedId: "",
      placeholder: communityImagePlaceholder,
    },
    h5Text: "Proven Leadership Methodology",
    pText:
      "Our framework has helped executives at Google, Microsoft, and Amazon achieve breakthroughs, refined through 10,000+ coaching hours across 30+ industries.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HomepageBlock4_2",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Coaching + Community = Unstoppable Growth",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
        createPBlock({
          text: "At Clarity Coaching, we combine expert coaching with a powerful network of leaders. You get tailored support, peer-driven insights, and an ongoing learning environment that accelerates your success.",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(card => createCardBlock(card)),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getHomepageBlockPrimaryStyleOptions(),
      },
    },
  },
};
